import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventComponent } from './event.component';
import { EventDetailsComponent } from './event-details/event-details.component';

const routes: Routes = [
  
  {
    path: '',
    component: EventComponent,
    data: {
        title: 'Event'
    },
    pathMatch: 'full'
  },
  {
    path: 'event_details/:albumName',
    component: EventDetailsComponent,
    data: {
        title: 'Event Details'
    }
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventRoutingModule { }
